import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { resolveBackHref } from '@app/shared/utils/back-href.util';
import { IonicModule, IonRouterOutlet } from '@ionic/angular';

@Component({
  selector: 'c-condensed-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
  templateUrl: './condensed-header.component.html',
  styleUrl: './condensed-header.component.scss',
})
export class CondensedHeaderComponent {
  readonly title = input.required<string>();

  private readonly routerOutlet = inject(IonRouterOutlet, { optional: true });
  private readonly router = inject(Router);

  protected readonly resolvedHref = computed(() => resolveBackHref(this.router));
  protected readonly isSubpage = computed(() => !!this.routerOutlet?.canGoBack() || !!this.resolvedHref());
}
